import React, { Component } from 'react'
import numeral from 'numeral'
import { utcToLocalDateTimeFormat } from '../../helpers/timeHelper'
import { RefiTransactionsCard as LienholderCard } from '../refiTransactions/refiTransactionsCard'
import { RefiTransactionsRow as LienholderRow } from '../refiTransactions/refiTransactionsRow'

import { Task, LienholderInfo } from './types'

export interface Props {
  task: Task
}

export default class TaskPayoffDetails extends Component<Props> {
  render() {
    const { task } = this.props
    const {
      payoffExpiresOn,
      perDiem,
      totalPayoffAmount,
      verifiedPayoffAmount,
    } = task.verifiables[0] as LienholderInfo

    return (
      <LienholderCard title="PAYOFF VERIFICATION DETAILS">
        {verifiedPayoffAmount && (
          <LienholderRow field="Verified payoff amount" fieldsBold>
            {numeral(verifiedPayoffAmount).format('$0,0')}
          </LienholderRow>
        )}
        {perDiem && (
          <LienholderRow field="Per diem" fieldsBold>
            {numeral(perDiem).format('$0,0.00')}
          </LienholderRow>
        )}
        {totalPayoffAmount && (
          <LienholderRow field="Total payoff amount" fieldsBold>
            {numeral(totalPayoffAmount).format('$0,0')}
          </LienholderRow>
        )}
        {payoffExpiresOn && (
          <LienholderRow field="Payoff good through" fieldsBold>
            {utcToLocalDateTimeFormat(payoffExpiresOn)}
          </LienholderRow>
        )}
      </LienholderCard>
    )
  }
}
